/**
 * Détecte si l'app tourne dans Despia (app native iOS/Android)
 */
export function isDespia(): boolean {
  if (typeof navigator === "undefined") return false;
  return navigator.userAgent.includes("despia");
}

/**
 * Détecte si on est sur iOS natif via Despia
 */
export function isDespiaIOS(): boolean {
  if (!isDespia()) return false;
  return /iPhone|iPad|iPod/.test(navigator.userAgent);
}

/**
 * Détecte si on est sur Android natif via Despia
 */
export function isDespiaAndroid(): boolean {
  if (!isDespia()) return false;
  return /Android/.test(navigator.userAgent);
}
